<template>
  <div id="app">
    <!-- <visualView> -->
    <!-- <meta name="viewport" content="width=device-width, initial-scale=1.0"> -->
    <!-- <Home/> -->
    <router-view></router-view>
  <!-- </visualView> -->
  </div>
</template>

<script>

import visualView from '@/components/common/Sizecss.vue'
export default {
  name: 'App',
  components: {
    // Home
    visualView
  },
}
</script>

<style lang="scss">
// @import url('./assets/css/reset.css');
html, body {
  // height: 100%;
  width: 100%;
}
#app {
  width: 100%;
  // height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  // font-size:calc(100vw * 16 / 1920);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 
}
</style>
